import { useCustomClearRefinements } from '@lib/hooks/useCustomClearRefinements';

const AutoCompleteControls = ({
  autoCompleteQuery,
  clearAutoComplete,
  closeAutoComplete,
}: {
  autoCompleteQuery: string | undefined;
  clearAutoComplete: VoidFunction;
  closeAutoComplete: VoidFunction;
}) => {
  const { refine, canRefine } = useCustomClearRefinements();

  const clearSearch = () => {
    clearAutoComplete();
    canRefine && refine();
  };

  return (
    <div className="ac-autocomplete__controls ch-display--flex ch-align-items--center ch-justify-content--end sl:ch-width--2">
      {autoCompleteQuery && (
        <button
          className="ch-btn ch-btn--link ch-color--ac-black ch-bc--grey-4 ch-br--1 ch-fs--2 sm:ch-fs--3 ch-text-decoration--none ch-mr--1"
          data-gtm-track="click_cta"
          data-gtm-track-label="Instant search - clear search"
          onClick={clearSearch}
          type="button"
        >
          Clear
        </button>
      )}
      <button
        className="ch-btn ch-ba--0 ch-mr--2 ac-autocomplete__close"
        onClick={closeAutoComplete}
        type="button"
      >
        <span className="ch-reader">Close search</span>
      </button>
    </div>
  );
};

export default AutoCompleteControls;
